import { getCurrentApiEndpoint } from "../../../constants/envs";

export const warmupLambdas = () => {
  const apiUrl = getCurrentApiEndpoint();
  fetch(`${apiUrl}/api/health/version`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });
};
